import { BILL_AUDIT } from "./constants";
import { openBillAuditWindow } from "./billAuditSession";

const DEFAULT_BILL_AUDIT_BASE = "https://billaudituat.gsevenpro.com";

export const buildBillAuditAuditUrlForMapping = (
  billMappingId?: number | string | null,
): string | null => {
  if (billMappingId == null || billMappingId === "") {
    return null;
  }
  const base = (BILL_AUDIT || DEFAULT_BILL_AUDIT_BASE).replace(/\/$/, "");
  return `${base}/audit/${billMappingId}?platform=G7`;
};

export const buildBillAuditAuditUrl = (
  billMappingId?: number | string | null,
  healthCareId?: number | string | null,
  schemeType?: string | null,
): string | null => {
  if (billMappingId == null || billMappingId === "" || healthCareId == null) {
    return null;
  }
  const base = (BILL_AUDIT || DEFAULT_BILL_AUDIT_BASE).replace(/\/$/, "");
  const scheme =
    schemeType?.toUpperCase() === "TPA" ? "TPA" : "CGHS";
  return `${base}/audit/${billMappingId}?healthcare_id=${healthCareId}&scheme_type=${scheme}&platform=G7`;
};

export const openBillAuditForMapping = (
  billMappingId?: number | string | null,
  healthCareId?: number | string | null,
  schemeType?: string | null,
): void => {
  const url =
    healthCareId != null && healthCareId !== ""
      ? buildBillAuditAuditUrl(billMappingId, healthCareId, schemeType)
      : buildBillAuditAuditUrlForMapping(billMappingId);
  openBillAuditWindow(url);
};

export { openBillAuditWindow };
